import { sampleAamvaObjectSnapshot, sampleBarcodeHorizontalSvg, sampleBarcodeVerticalSvg, } from '../../../../backend/features/barcodesAamvaBadge/shared';
export const sampleImageGenerationBarcodeData = {
    barcodeAamvaData: sampleAamvaObjectSnapshot,
    barcodeHorizontalSvg: sampleBarcodeHorizontalSvg,
    barcodeVerticalSvg: sampleBarcodeVerticalSvg,
};
